export const getTrueFalse = dataParam => dataParam ? 'true' : 'false';
